module.exports = __webpack_public_path__ + "static/media/zfb.b2da8476.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/zfb.ico
// module id = 222
// module chunks = 0